const MovieTypes = {
  GET_MOVIE : 'GET_MOVIE',
  GET_MOVIE_DETAILS: 'GET_MOVIE_DETAILS',
  FETCH_START: 'FETCH_START',
  FETCH_INFINITE_START : 'FETCH_INFINITE_START',
  FETCH_SUCCESS:'FETCH_SUCCESS',
  FETCH_DETAIL_SUCCESS:'FETCH_DETAIL_SUCCESS',
  SEARCH_SUCCESS : 'SEARCH_SUCCESS',
  SEARCH_DETAIL_SUCCESS:'SEARCH_DETAIL_SUCCESS',
  FETCH_FAILURE:'FETCH_FAILURE',
  GET_KEYWORD:'GET_KEYWORD',
  CLEAR_ARRAY:'CLEAR_ARRAY',
}

export default MovieTypes;